export default "__VITE_PUBLIC_ASSET__05ed47cf__"